import { Popover, Space, Typography } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";

const { Text } = Typography;

function DisplayNameListPopover({
  list,
  children,
  placement = undefined
}: {
  list: Array<{ name: string; id?: string }>;
  children: any;
  placement?: TooltipPlacement;
}) {
  const content = (
    <div className="overflow-y-auto max-h-96 space-y-2 flex-col flex">
      {list.map((l) => (
        <div
          className="w-60 px-2 border border-solid border-gray-300"
          key={l.name}
        >
          <Text
            className="w-full py-1"
            ellipsis={{ tooltip: l.name, suffix: "" }}
          >
            {l.name}
          </Text>
        </div>
      ))}
    </div>
  );
  return (
    <Popover content={content} placement={placement}>
      <Space className="px-1 cursor-pointer text-blue-600">{children}</Space>
    </Popover>
  );
}
export default DisplayNameListPopover;
